<template>
    <span>
        <span
            :class="{'active': active}"
            :data-clicklabel="options ? options.Text : ''"
            :data-clickaction="'click-header ' + websiteType"
            data-clickcategory="header"
            class="padding pointer hover-color"
            @click="pushItem($event)"
            v-html="options ? options.Text : ''"
        />
    </span>
</template>
<script>
export default {
    name: 'TopMenuElement',
    props: {
        options: {
            type: Object,
            default() {
                return {
                    url: ''
                };
            }
        },
        active: {
            type: Boolean,
            default() {
                return false;
            }
        },
        websiteType: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            firstClick: true
        };
    },
    methods: {
        pushItem() {
            if ('ontouchstart' in document.documentElement && this.firstClick) {
                this.firstClick = true;
                setTimeout(() => {
                    this.firstClick = false;
                }, 100);
            } else {
                window.location.assign(this.options.Url);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.pointer {
    cursor: pointer;
}

.padding {
    padding: 4px;
}
</style>
